module.exports = __webpack_public_path__ + "static/media/40.91a8b56f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/40.jpg
// module id = 987
// module chunks = 0